import $ from 'jquery';
import Accordion from '@shopify/marketing-assets/javascripts/modules/accordion';

function initializeAccordion() {
  $('.js-accordion').each((i, el) => {
    const accordion = new Accordion($(el), {
      mobileOnly: false,
      itemSelector: '.accordion-item',
      openFirst: false,
    });

    if ($(el).hasClass('js-open-accordion')) {
      accordion.$accordionItems.each((index, item) => {
        accordion.toggle($(item), false);
      });
    }
  });
}

export default initializeAccordion;
